import { PaletteOptions, Color as MUIColor } from '@mui/material';

import { lighten, darken } from 'color2k';

type Color = Omit<MUIColor, 'A100' | 'A200' | 'A400' | 'A700'>;

export const primary = '#F36C21';
// export const secondary = '#260D39';

export const grey: Color = {
  50: '#F7FAFC',
  100: '#EDF2F7',
  200: '#E2E8F0',
  300: '#CBD5E0',
  400: '#A0AEC0',
  500: '#718096',
  600: '#4A5568',
  700: '#2D3748',
  800: '#1A202C',
  900: '#171923'
};

// Red color from Material-Design Colors
export const red: Color = {
  50: '#FFEBEE',
  100: '#FFCDD2',
  200: '#EF9A9A',
  300: '#E57373',
  400: '#EF5350',
  500: '#F44336',
  600: '#E53935',
  700: '#D32F2F',
  800: '#C62828',
  900: '#B71C1C'
};

// Amber color from Material-Design Colors
export const yellow: Color = {
  50: '#FFF8E1',
  100: '#FFECB3',
  200: '#FFE082',
  300: '#FFD54F',
  400: '#FFCA28',
  500: '#FFC107',
  600: '#FFB300',
  700: '#FFA000',
  800: '#FF8F00',
  900: '#FF6F00'
};

// Blue color from Material-Design Colors
export const blue: Color = {
  50: '#E1F5FE',
  100: '#B3E5FC',
  200: '#81D4FA',
  300: '#4FC3F7',
  400: '#29B6F6',
  500: '#03A9F4',
  600: '#039BE5',
  700: '#0288D1',
  800: '#0277BD',
  900: '#01579B'
};

// Green color from Material-Design Colors
export const green: Color = {
  50: '#E8F5E9',
  100: '#C8E6C9',
  200: '#A5D6A7',
  300: '#81C784',
  400: '#66BB6A',
  500: '#4CAF50',
  600: '#43A047',
  700: '#388E3C',
  800: '#2E7D32',
  900: '#1B5E20'
};

const palette: PaletteOptions = {
  common: {
    black: '#000',
    white: '#FFF'
  },
  grey: { ...grey },
  text: {
    primary: grey[900],
    secondary: grey[400],
    disabled: grey[200]
  },
  divider: grey[200],
  background: {
    paper: grey[100],
    default: '#FFF'
  },
  primary: {
    light: lighten(primary, 0.25),
    main: primary,
    dark: darken(primary, 0.25)
    // contrastText: '#',
  },
  secondary: {
    light: grey[100],
    main: grey[500],
    dark: grey[800]
    // contrastText: '#',
  },
  error: {
    light: red[100],
    main: red[500],
    dark: red[800]
    // contrastText: '#',
  },
  warning: {
    light: yellow[100],
    main: yellow[500],
    dark: yellow[800]
    // contrastText: '#',
  },
  info: {
    light: blue[100],
    main: blue[500],
    dark: blue[800]
    // contrastText: '#',
  },
  success: {
    light: green[100],
    main: green[500],
    dark: green[800]
    // contrastText: '#',
  }
};

export default palette;
